import api from './api/axiosConfig';

/** Unwrap ApiResponse envelope when present (RULE §9). */
function unwrap(res) {
  const d = res?.data;
  if (d && typeof d.success === 'boolean' && 'data' in d) return d.data;
  return d;
}

const inquiryService = {
  async createInquiry(inquiryData) {
    const response = await api.post('/inquiries/', inquiryData);
    return unwrap(response);
  },

  async submitInquiry(inquiryData) {
    return inquiryService.createInquiry(inquiryData);
  },

  async getInquiries(params = {}) {
    const response = await api.get('/inquiries/list/', { params });
    return unwrap(response);
  },

  async getMyInquiries() {
    const response = await api.get('/inquiries/my/');
    return unwrap(response);
  },

  async getInquiry(id) {
    const response = await api.get(`/inquiries/${id}/`);
    return unwrap(response);
  },

  async updateInquiryStatus(id, statusData) {
    const response = await api.patch(`/inquiries/${id}/status/`, statusData);
    return unwrap(response);
  },

  async updateInquiry(id, inquiryData) {
    const response = await api.patch(`/inquiries/${id}/`, inquiryData);
    return unwrap(response);
  },

  async deleteInquiry(id) {
    await api.delete(`/inquiries/${id}/`);
    return true;
  },
};

export default inquiryService;
